import React from 'react';
import { RecordContextProvider, DatagridBody, useRecordContext } from 'react-admin';
import { TableCell, TableRow } from '@mui/material';

/** Props for the internal "no records" row rendered by {@link RaBody}. */
interface MyDatagridRowProps {
    /** The `<Field>` elements for the current row's columns, used only to compute `colSpan`. */
    children?: React.ReactNode;
}

/** Placeholder row rendered by `RaBody` in place of the real datagrid rows (see {@link RaBody}). */
const MyDatagridRow: React.FC<MyDatagridRowProps> = ({ children }) => {
    const record = useRecordContext();
    const colSpan = React.Children.toArray(children).filter(child => React.isValidElement(child)).length;
    return (
        <RecordContextProvider value={record}>
            <TableRow className='no-records'>
                <TableCell colSpan={colSpan}>
                    No records found
                </TableCell>
            </TableRow>
        </RecordContextProvider>
    );
};

/** Props for {@link RaBody} — identical to react-admin's `DatagridBody`. */
type RaBodyProps = React.ComponentProps<typeof DatagridBody>;

/**
 * `DatagridBody` variant that always renders a single "No records found" row instead of the
 * real rows. Used by {@link RaList} to render an empty-but-not-loading state.
 */
const RaBody: React.FC<RaBodyProps> = (props) => (<DatagridBody {...props} row={<MyDatagridRow />} />);

export default React.memo(RaBody);
